/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-05 10:26:21
 */
export default [
  {
    path: '/download',
    // route name 参与按名导航和 visited-view 缓存，父子必须唯一；用户可见标题仍由 meta.title 提供。
    name: 'downloadLayout',
    component: () => import('@/views/Application.vue'),
    hidden: false,
    meta: {
      title: '选手材料管理',
      icon: 'fa fa-star iconTitle',
      role: ['scene_control'],
      level: 1
    },
    children: [
      {
        path: '/download',
        name: 'downloadCourse',
        hidden: false,
        component: () => import('@/views/download/DownloadCourse.vue'),
        meta: {
          title: '选手材料管理',
          icon: 'fa fa-star iconTitle',
          role: ['scene_control'],
          level: 1
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/download/index.js